document.addEventListener('DOMContentLoaded', () => {

  const appId = 'WJ565UKL66';
  const apiKey = 'acb510d2436b643c5ea998ba383924ae';
  const store = 'vineapparel';

  let client;

  const updateSearchScrollLock = () => {
    const isOpen = [...document.querySelectorAll('[data-predictive-search-results]')]
      .some(container => !container.hidden);

    document.body.classList.toggle('predictive-search-open', isOpen);
  };

  const initSearch = () => {
    if (typeof algoliasearch === 'function') {
      client = algoliasearch(appId, apiKey);
      console.log("✅ Algolia manual client initialized.");

      const instances = Array.from(document.querySelectorAll('[data-predictive-search-instance]'))
        .map(setupInstance)
        .filter(Boolean);

      // Shared outside-click / Escape handling.
      // "Inside" = the search input wrap or the portaled results only.
      // Anything else (backdrop, close button, rest of the page) closes it.
      // pointerdown fires before other click handlers can re-open things.
      document.addEventListener('pointerdown', (event) => {
        instances.forEach(({ instance, resultsContainer, searchContainer, close }) => {
          const isOpen =
            !resultsContainer.hidden ||
            (searchContainer && searchContainer.classList.contains('is-active'));
          if (!isOpen) return;

          const insideInput = instance.querySelector('.search__input-wrap')?.contains(event.target);
          const insideResults = resultsContainer.contains(event.target);

          if (!insideInput && !insideResults) close();
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          instances.forEach(({ close }) => close());
        }
      });
    } else {
      console.log("⏳ Waiting for algoliasearch library...");
      setTimeout(initSearch, 200);
    }
  };

  const setupInstance = (instance) => {
    const input = instance.querySelector('[data-predictive-search-input]');
    const resultsContainer = instance.querySelector('[data-predictive-search-results]');
    if (!input || !resultsContainer) return null;

    // Move results out of any clipped/transformed ancestor (e.g. .drawer with
    // overflow:hidden) so it can render above everything.
    document.body.appendChild(resultsContainer);
    resultsContainer.classList.add('predictive-search-wrapper--portaled');

    const drawerEl = instance.closest('.drawer');
    const searchContainerSelector = drawerEl ? '.drawer' : '.site-header__search-container';

    const searchContainer =
      instance.closest(searchContainerSelector) ||
      document.querySelector(searchContainerSelector);

    // One place for all close/cleanup logic
    const close = () => {
      resultsContainer.hidden = true;
      searchContainer?.classList.remove('is-active');
      input.value = '';
      input.blur();
      updateSearchScrollLock();
    };

    const positionResults = () => {
      const searchInputContainer = input.closest('.algolia-search-input');
      if (!searchInputContainer) return;

      const rect = searchInputContainer.getBoundingClientRect();

      // Dropdown can be wider than the search input
      const maxWidth = 1024;
      const width = Math.min(window.innerWidth - 30, maxWidth);

      // Center dropdown relative to the search input
      const centerX = rect.left + rect.width / 2;
      const left = Math.max(0, Math.min(
        centerX - width / 2,
        window.innerWidth - width
      ));

      resultsContainer.style.position = 'fixed';
      resultsContainer.style.top = `${rect.bottom}px`;
      resultsContainer.style.left = `${left}px`;
      resultsContainer.style.right = 'auto';
      resultsContainer.style.width = `${width}px`;
      resultsContainer.style.maxWidth = `${maxWidth}px`;
      resultsContainer.style.margin = '0';

      resultsContainer.style.setProperty(
        '--predictive-search-top',
        `${rect.bottom}px`
      );
    };

    let timeout;

    input.addEventListener('input', () => {
      const query = input.value.trim();
      if (timeout) clearTimeout(timeout);

      if (!query) {
        resultsContainer.hidden = true;
        updateSearchScrollLock();
        return;
      }

      timeout = setTimeout(async () => {
        try {
          const { results } = await client.multipleQueries([
            { indexName: 'vineapparel_products_query_suggestions', query, params: { hitsPerPage: 5 } },
            { indexName: 'vineapparel_products', query, params: { hitsPerPage: 4, filters: 'inventory_available:true', distinct: 1 } },
            { indexName: 'vineapparel_collections', query, params: { hitsPerPage: 3 } },
            { indexName: 'vineapparel_pages', query, params: { hitsPerPage: 3 } },
            { indexName: 'vineapparel_redirect', query, params: { hitsPerPage: 1 } },
          ]);

          if (input.value.trim() !== query) return;

          renderAll(resultsContainer, results, query);
          positionResults();
          resultsContainer.hidden = false;
          updateSearchScrollLock();
        } catch (err) {
          console.error("Search failed:", err);
        }
      }, 150);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        const query = input.value.trim();
        if (!query) return;
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      }
    });

    const submitButton = instance.querySelector('.btn--search');
    if (submitButton) {
      submitButton.addEventListener('click', (event) => {
        event.preventDefault();
        const query = input.value.trim();
        if (!query) return;
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      });
    }

    let resizeTimeout;
    window.addEventListener('resize', () => {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (!resultsContainer.hidden) positionResults();

        if (drawerEl && drawerEl.offsetParent === null) {
          close();
        }
      }, 100);
    });

    if (drawerEl) {
      const drawerObserver = new MutationObserver(() => {
        // Only close search when the drawer is actually hidden
        const isDrawerVisible = drawerEl.getClientRects().length > 0;

        if (!isDrawerVisible) {
          close();
        }
      });

      drawerObserver.observe(drawerEl, {
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
    }

    return { input, resultsContainer, instance, searchContainer, close };
  };

  const renderAll = (resultsContainer, results, query) => {
    console.log(results);

    const data = results[4]?.userData;
    if (data != null) {
      window.location.href = data[0].redirect;
    }

    const suggestions = (results[0] && results[0].hits) ? results[0].hits : [];
    const products    = (results[1] && results[1].hits) ? results[1].hits : [];
    const collections = (results[2] && results[2].hits) ? results[2].hits : [];
    const pages       = (results[3] && results[3].hits) ? results[3].hits : [];

    const pagesEl = resultsContainer.querySelector('[data-type-pages]');
    const collectionsEl = resultsContainer.querySelector('[data-type-collections]');
    const productsEl = resultsContainer.querySelector('[data-type-products]');
    const suggestionsEl = resultsContainer.querySelector('[data-type-suggestions]');

    if (pagesEl) {
      pagesEl.innerHTML = pages.length ? pages.map(p => `
        <li><a href="/pages/${p.handle}"><span>${p.title}</span></a></li>
      `).join('') : '<li>No pages found</li>';
      if (pages.length == 0) { pagesEl.style.display = 'none'; }
    }

    if (collectionsEl) {
      collectionsEl.innerHTML = collections.length ? collections.map(c => `
        <li><a href="/collections/${c.handle}"><span>${c.title}</span></a></li>
      `).join('') : '<li>No collections found</li>';
      if (collections.length == 0) { collectionsEl.style.display = 'none'; }
    }

    if (productsEl) {
      productsEl.innerHTML = products.length ? products.map(p => `
        <div class="product-item">
          <a href="/products/${p.handle}" class="product-item__link">
            <div class="product-item__image">
              <img src="${p.image_url || p.image || ''}" width="60" loading="eager">
            </div>
            <div class="product-item__info">
              <p class="product-item__title"><strong>${p.title}</strong></p>
              <div class="product-price-container">
                <p class="product-item__price ${p.compare_at_price != 0 ? 'active' : ''}">$${parseFloat(p.price || 0).toFixed(2)}</p>
                <div class="${p.compare_at_price == p.price ? 'hide' : ''}">
                  <p class="product-item__price_compare ${p.compare_at_price != 0 ? 'active' : ''}">$${parseFloat(p.compare_at_price || 0).toFixed(2)}</p>
                </div>
              </div>
            </div>
          </a>
        </div>
      `).join('') : '<p>No products found</p>';
    }

    if (suggestionsEl) {
      suggestionsEl.innerHTML = suggestions.length ? suggestions.map(s => `
        <li><a href="/search?q=${encodeURIComponent(s.query)}"><span>${s.query}</span></a></li>
      `).join('') : '<li>No suggestions</li>';
      if (suggestions.length == 0) { suggestionsEl.style.display = 'none'; }
    }

    let footer = resultsContainer.querySelector('.predictive-search__footer');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'predictive-search__footer';
      resultsContainer.appendChild(footer);
    }

    footer.innerHTML = `
      <a href="/search?q=${encodeURIComponent(query)}" class="predictive-search__all-results">
        <span>See all results for "<strong>${query}</strong>"</span>
      </a>
    `;

    footer.onclick = () => {
      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    };
  };

  initSearch();

  document.addEventListener('algolia.hooks.initialize', function() {
    const productCache = new Map();
    const hitsContainer = document.querySelector('.ais-hits-container');

    if (!hitsContainer) return;

    const observer = new MutationObserver(() => {
      const noHits = hitsContainer.querySelector('.ais-hit-empty');
      const page = document.querySelector('.ais-page');

      if (noHits) {
        page.classList.add('no-results');
        document.querySelector('.no-results-container').style.display = 'block';
        document.querySelector('#algolia-shopify-instantsearch').style.minHeight = '0px';
      } else {
        page.classList.remove('no-results');
      }
    });

    observer.observe(hitsContainer, { childList: true, subtree: true });

    algoliaShopify.hooks.registerHook(
      "beforeInstantSearchMainTemplate",
      (_defaultTemplate, data, html) => {
        return html`
          <div class="ais-page">
            <h1 class="section-header__title">Search</h1>
            <div class="ais-input">
              <div class="ais-search-box-container"></div>
              <div class="ais-input-button">
                <div class="ais-clear-input-icon"></div>
              </div>
            </div>
            <hr/>
            ${data.facets.length > 0 ? html`
              <div class="ais-facets-button">
                ${algoliaShopify.translations.showFilters}
              </div>
              <div class="ais-facets">
                <div class="ais-clear-refinements-container"></div>
                <div class="ais-current-refined-values-container"></div>
                ${
                  algoliaShopify.config.app_blocks_dynamic_widgets_beta_enabled
                    ? html`
                      <div class="ais-dynamic-widgets-container"></div>
                    `
                    : data.facets.map(facet => html`
                      <div
                        class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                      >
                        <label
                          for="${facet.escapedName}"
                          class="ais-range-slider--header ais-facet--header ais-header"
                          >${facet.title}</label
                        >
                        <input
                          class="ais-dropdown-checkbox"
                          type="checkbox"
                          id="${facet.escapedName}"
                          name="dropdown"
                        />
                        <div
                          class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                        ></div>
                      </div>
                    `)
                }
              </div>
            ` : ''}
            <div class="ais-block">
              <div class="ais-search-header">
                <div class="ais-stats-container"></div>
                <div class="ais-change-display">
                  <span class="ais-change-display-block ais-change-display-selected"
                    ><i class="fa fa-th-large"></i
                  ></span>
                  <span class="ais-change-display-list"
                    ><i class="fa fa-th-list"></i
                  ></span>
                </div>
                <div class="ais-sort">
                  ${
                    data.multipleSortOrders
                      ? html`
                        ${algoliaShopify.translations.sortBy}
                        <span class="ais-sort-orders-container"></span>
                      `
                      : html`
                        ${algoliaShopify.translations.sortBy}
                        ${algoliaShopify.translations.relevance}
                      `
                  }
                </div>
              </div>
              <div class="ais-hits-container ais-results-as-block"></div>
            </div>
            <div class="ais-pagination-container"></div>
          </div>
        `;
      }
    );

    algoliaShopify.hooks.registerHook(
      "beforeInstantSearchFacetParamsOptions",
      (params, facet) => {
        return {
          ...params,
          transformItems(items) {
            return items
              .map(item => ({
                ...item,
                label: item.label.toLowerCase(),
              }))
              .sort((a, b) => {
                const na = parseFloat(a.label);
                const nb = parseFloat(b.label);

                const aIsNum = !isNaN(na);
                const bIsNum = !isNaN(nb);

                if (aIsNum && bIsNum) return na - nb;
                if (aIsNum) return -1;
                if (bIsNum) return 1;

                return a.label.localeCompare(b.label);
              });
          }
        };
      }
    );

    algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(hit) {
      const productId = hit.props['data-product-id'];
      const handle = hit.props['data-handle'];

      const placeholder = `
        <div class="grid-product grid-product--custom" data-product-id="${productId}">
          <div class="grid-product__image-wrapper skeleton skeleton-image" style="max-height:400px; overflow:hidden; position:relative; aspect-ratio:4/6;"></div>
          <div class="grid-product__meta">
            <h3 class="grid-product__title">
              <div class="skeleton skeleton-text" style="width:70%; height:1.2em;"></div>
            </h3>
            <div class="grid-product__price">
              <div class="skeleton skeleton-text" style="width:40%; height:1em;"></div>
            </div>
          </div>
          <div class="grid-product__colors grid-product__colors--${handle}"></div>
        </div>
      `;

      setTimeout(() => {
        getProductData(handle).then(product => {
          const container = document.querySelector(`.grid-product[data-product-id="${productId}"]`);
          if (!container) return;

          const title = product.title;
          const defaultVariant = product.variants[0];
          const price = defaultVariant.price / 100;
          const compareAtPrice = defaultVariant.compare_at_price ? defaultVariant.compare_at_price / 100 : null;
          const onSale = compareAtPrice && compareAtPrice > price;
          const available = product.available;

          const isPetite = product.tags.includes("petite");

          let availableHTML = '';
          let availableBG = '';
          let saleBadgeHTML = '';

          if (onSale) {
            const discount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
            saleBadgeHTML = `
              <div class="grid-product__tag grid-product__tag--amount-saving">
                ${discount}% Off
              </div>
            `;
          }

          if(!available){
            availableBG = "not-available";
            availableHTML = `
              <div class="no-stock">
                <button type="button" class="btn btn--full sold-out js-modal-open-oosmodal" data-sold-out-btn="" aria-expanded="false">
                  <span data-add-to-cart-text="" data-default-text="Add to cart">
                    Get Notified
                  </span>
                </button>
              </div>
            `;
          }

          container.innerHTML = `
            ${availableHTML}
            <div class="grid-product__image-wrapper ${availableBG}" style="max-height:400px; overflow:hidden; position:relative; aspect-ratio:4/6; height: 100%;">
              <div class="product-gallery flickity-slider--${handle}"></div>
              ${saleBadgeHTML}
              ${isPetite ? `<div class="grid-product__band grid-product__band--petite">Petite</div>` : ''}
            </div>
            <div class="grid-product__meta">
              <h3 class="grid-product__title">
                <a href="/products/${handle}" class="grid-product__link">${title}</a>
              </h3>
              <div class="grid-product__price${onSale ? ' grid-product__price--sale' : ''}">
                $${price.toFixed(2)}&nbsp;
                <span class="visually-hidden">Regular price</span>
                ${onSale ? `<span class="grid-product__price--original">$${compareAtPrice.toFixed(2)}</span><span class="visually-hidden">Sale price</span>` : ''}
              </div>
            <div class="grid-product__colors grid-product__colors--${handle}"></div>
          `;

          buildSwatchesAndGallery(container, handle, product);
        });
      }, 0);

      return placeholder;
    });

    algoliaShopify.hooks.registerHook(
      "beforeInstantSearchNoResultTemplate",
      (_defaultTemplate, html) => {
        const inputEl = document.querySelector('.ais-SearchBox-input');
        const query = inputEl ? inputEl.value : '';

        return html`
          <div class="ais-hit-empty" style="margin:0;">
            <div class="ais-hit-empty--title">
              <div class="section-header">
                <h2 class="h2 text-center">${algoliaShopify.translations.noResultFound} for "${query}"</h2>
              </div>
            </div>
          </div>
        `;
      }
    );

    algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function(_defaultTemplate, data, html) {
      const block = document.querySelector('.ais-page .ais-block');
      if (block) block.style.opacity = "1";

      return html`
        ${data.hasOneResult &&
          html`
            <span class="ais-stats--nb-results">
              1 result found
            </span>
          `}
        ${data.hasManyResults &&
          html`
            <span class="ais-stats--nb-results" style="font-weight: 400">
              ${' '} ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '}
              results found
            </span>
          `}
      `;
    });

    async function getProductData(handle) {
      if(productCache.has(handle)) return productCache.get(handle);
      const res = await fetch(`/products/${handle}.js`);
      const data = await res.json();
      productCache.set(handle, data);
      return data;
    }

    function buildSwatchesAndGallery(container, handle, product) {
      const colorOptionIndex = product.options.findIndex(opt => /color|colour/i.test(opt.name));
      const sizeOptionIndex  = product.options.findIndex(opt => /size/i.test(opt.name));

      const hasColorOption = colorOptionIndex !== -1;
      const hasSizeOption  = sizeOptionIndex !== -1;

      const colors = hasColorOption
        ? [...new Set(product.variants.map(v => v[`option${colorOptionIndex + 1}`]))]
            .filter(c => c)
        : [];

      if (colors.length > 1) {
        const MAX_SWATCHES = 4;
        const visibleColors = colors.slice(0, MAX_SWATCHES);
        const remainingCount = colors.length - visibleColors.length;

        const swatchesMarkup = visibleColors.map((color, index) => {
          const swatchClass = color.toLowerCase().replace(/\s+/g, '-');
          const swatchImg = product.media.find(m =>
            m.media_type === 'image' &&
            m.alt &&
            m.alt.toLowerCase().includes('swatch') &&
            m.src.toLowerCase().includes(swatchClass)
          );

          return `<a href="#"
            class="color-swatch color-swatch--small color-swatch--${swatchClass} ${index === 0 ? 'is-active' : ''} color-swatch--click"
            data-product-id="${handle}"
            data-variant-color="${color}"
            aria-label="${color}"
            style="${swatchImg
              ? `background-image:url('${swatchImg.src}&width=50&height=50')`
              : `background-color:${color}`}">
            <span class="visually-hidden">${color}</span>
          </a>`;
        }).join('');

        const moreMarkup = remainingCount > 0
          ? `<span class="color-swatch--more">+${remainingCount} more</span>`
          : '';

        const swatchContainer = container.querySelector(`.grid-product__colors--${handle}`);
        if (swatchContainer) swatchContainer.innerHTML = swatchesMarkup + moreMarkup;
      }

      renderGallery(container, handle, product, hasColorOption ? colorOptionIndex : null);
    }

    function renderGallery(container, handle, product, colorOptionIndex) {

      const galleryContainer = container.querySelector(`.flickity-slider--${handle}`);
      if (!galleryContainer) return;

      const activeSwatch = container.querySelector(`.grid-product__colors--${handle} .color-swatch.is-active`);
      const activeColor = activeSwatch
        ? activeSwatch.dataset.variantColor.toLowerCase().replace(/\s+/g, '')
        : null;

      const imageSlides = (product.media || [])
        .filter(m =>
          m.media_type === 'image' &&
          !(m.alt || '').toLowerCase().includes('swatch')
        )
        .map((img, index) => {

            const imgSrc =
              img.src ||
              img.image?.src ||
              img.preview_image?.src ||
              '';

            return `
              <div class="gallery-cell"
                  data-color="${(img.alt || '').toLowerCase()}"
                  style="width:100%;position:relative;">

                <a href="/products/${handle}"
                  class="gallery-cell-link-overlay"
                  style="position:absolute;height:100%;width:100%;z-index:2;"></a>

                <img
                  src="${imgSrc}&width=500"
                  ${index !== 0 ? `data-flickity-lazyload="${imgSrc}&width=500"` : ''}
                  alt="${img.alt || product.title}"
                  width="500"
                  height="500"
                  loading="${index === 0 ? 'eager' : 'lazy'}"
                >
              </div>
            `;
          })
        .join('');

        galleryContainer.innerHTML = imageSlides;

        galleryContainer.style.opacity = 0;

        const slides = Array.from(galleryContainer.querySelectorAll('.gallery-cell'));

        const initialIndex = Math.max(
          0,
          slides.findIndex(slide =>
            activeColor &&
            (slide.dataset.color || '')
              .replace(/\s+/g, '')
              .includes(activeColor)
          )
        );

        requestAnimationFrame(() => {

          const flkty = new Flickity(galleryContainer, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: true,
            draggable: false,
            lazyLoad: 2,
            adaptiveHeight: true,
            initialIndex: initialIndex
          });

          galleryContainer.style.opacity = 1;

          if (colorOptionIndex !== null) {

            container.querySelectorAll(`.grid-product__colors--${handle} .color-swatch--click`)
              .forEach(swatch => {

                swatch.addEventListener('click', e => {
                  e.preventDefault();

                  const color = swatch.dataset.variantColor
                    .toLowerCase()
                    .replace(/\s+/g, '');

                  const slides = Array.from(
                    galleryContainer.querySelectorAll('.gallery-cell')
                  );

                  const targetIndex = slides.findIndex(slide =>
                    (slide.dataset.color || '')
                      .replace(/\s+/g, '')
                      .includes(color)
                  );

                  if (targetIndex >= 0) flkty.select(targetIndex);

                  container.querySelectorAll('.color-swatch')
                    .forEach(s => s.classList.remove('is-active'));

                  swatch.classList.add('is-active');

                  const variant = product.variants.find(v =>
                    v[`option${colorOptionIndex + 1}`] &&
                    v[`option${colorOptionIndex + 1}`]
                      .toLowerCase()
                      .replace(/\s+/g, '') === color
                  );

                  if (variant) {
                    const url = `/products/${handle}?variant=${variant.id}`;
                    container.querySelectorAll('a.grid-product__link')
                      .forEach(a => a.href = url);
                  }

                });

              });
          }

        });

        const block = document.querySelector('.ais-page .ais-block');
        if (block) block.style.opacity = "1";
    }
  });
});